import { render } from "./AlertDialog.vue?vue&type=template&id=3dfba0c0"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hayatokoba/projects/minakuni/minbo/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__